import pickBy from "lodash/pickBy";
import mapValues from "lodash/mapValues";
import keyBy from "lodash/keyBy";
import identity from "lodash/identity";
import every from "lodash/every";

import qs from "qs";
import { evalCondition } from "./conditions";
import MultiNumericField from "../fields/MultiNumericField";

function cleanObject(obj) {
  if (!obj) return {};
  return pickBy(obj, identity); // Remove falsey values
}

export function hasOriginalData(key) {
  return window.__DATA__ && window.__DATA__.data && !!window.__DATA__.data[key];
}

export function extractFields(fields) {
  if (!fields) return [];
  let fieldNames = [];
  for (const field of fields) {
    if (field.name) {
      fieldNames.push(field);
    }
    if (field.fields) {
      // TODO : handle list item fields differently !!!! (prefix ?)
      fieldNames = [...fieldNames, ...extractFields(field.fields)];
    }
    if (field.tabs) {
      fieldNames = [...fieldNames, ...extractFields(field.tabs)];
    }
  }
  return fieldNames;
}

export function extractCurrentFields(fields, data) {
  if (!fields) return [];
  let fieldNames = [];
  for (const field of fields) {
    if (evalCondition(field.condition, data)) {
      if (field.name || field.type === "MultiNumericField") {
        fieldNames.push(field);
      }
      if (field.fields && field.type !== "ListItem" && field.type !== "MultiNumericField") {
        fieldNames = [...fieldNames, ...extractCurrentFields(field.fields, data)];
      }
      if (field.tabs) {
        fieldNames = [...fieldNames, ...extractCurrentFields(field.tabs, data)];
      }
    }
  }
  return fieldNames;
}

export function extractRequiredFields(fields, data) {
  return extractCurrentFields(fields, data).filter((f) => (f.required || f.type === "ListItem") && !f.disabled);
}

function validateListItems(listItemField, items) {
  const { minItems, maxItems, fields } = listItemField;
  if (minItems && items.length < minItems) return false;
  if (maxItems && items.length > maxItems) return false;
  // console.log("validateListItems")

  for (const item of items) {
    if (!hasRequiredData(fields, item)) {
      return false;
    }
  }
  return true;
}

function isValidRequiredField(field, data) {
  switch (field.type) {
    case "ListItem": {
      const items = data[field.name] || [];
      return validateListItems(field, items);
    }
    case "MultiNumericField": {
      return MultiNumericField.validate(field, data);
    }
    default: {
      return !!data[field.name];
    }
  }
}

// TODO: validate when parsing tree instead of extracting first :/ or memoize ?
function hasRequiredDataInFlatFields(fields, data) {
  return every(fields, (field) => isValidRequiredField(field, data));
}

export function hasRequiredData(fields, data) {
  return hasRequiredDataInFlatFields(extractRequiredFields(fields, data), data);
}

export function initializeData(form, params) {
  const fields = extractFields(form); //.map(f => f.name);
  const defaultData = (window.__DATA__ && window.__DATA__.data) || {};
  const defaultValues = keyBy(
    fields.filter((f) => f.hasOwnProperty("defaultValue")),
    "name"
  );
  const defaultParams = mapValues(defaultValues, (field) => field.defaultValue);
  if (!params) {
    params = {
      ...defaultParams,
      ...defaultData,
      ...cleanObject(qs.parse(window.location.search, { ignoreQueryPrefix: true })),
    };
  } else {
    params = {
      ...defaultParams,
      ...defaultData,
      ...cleanObject(params),
    };
  }
  // console.log("params", params)
  // const fieldNames = fields.map(f => f.name);
  return mapValues(params /*pick(params, fieldNames)*/, (v) => {
    if (v === "true") return true;
    else if (v === "false") return false;
    return v;
  });
}

export function hasProducts(fields) {
  // TODO : optimize (simple recursion and/or memoize ?)
  return !!extractFields(fields).find((f) => f.type === "ProductField");
}

export function isUpdate() {
  return window.__DATA__ && window.__DATA__.isUpdate;
}
